import { render, staticRenderFns } from "./LaserbeamerView.vue?vue&type=template&id=97c187b0&scoped=true"
import script from "./LaserbeamerView.vue?vue&type=script&lang=js"
export * from "./LaserbeamerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c187b0",
  null
  
)

export default component.exports